import React, { Component, ComponentType } from 'react';

import PaginationMeta from '@interfaces/pagination-meta';

export interface PaginationWrapperHocProps {
    rows: any[];
    meta: PaginationMeta;
    isLoading: boolean;
    fetchPage(pageNumber?: number): void;
}

export interface PaginationWrapperProps {
    displayShowMore: boolean;
    isLoading: boolean;
    onClick(): any;
    fetchPage(pageNumber?: number): void;
}

type ComposedComponentProps = PaginationWrapperProps;
type Props = PaginationWrapperHocProps;

const defaultPaginationPropsMethod = function () {
    /* tslint:disable-next-line:no-invalid-this */
    return this.props;
};

export default function paginationWrapper<P>(
    ComposedComponent: ComponentType<P & ComposedComponentProps>,
    getPaginationProps?: any
) {
    return class extends Component<P & Props> {
        public static asyncFetchData = (ComposedComponent as any).asyncFetchData;

        private getPaginationProps = getPaginationProps || defaultPaginationPropsMethod;

        public componentDidMount() {
            // Загружает страницу первоначально, если не было серверного рендеринга.
            if (!this.getPaginationProps(this.props).rows.length) {
                this.props.fetchPage();
            }
        }

        public shouldComponentUpdate() {
            return true;
        }

        public onClick = () => {
            const { pageNumber } = this.getPaginationProps(this.props).meta;

            this.props.fetchPage(+pageNumber + 1);
        };

        public render() {
            const { meta, rows } = this.getPaginationProps(this.props);
            const displayShowMore = meta.totalSize > rows.length;

            return (
                <ComposedComponent
                    onClick={this.onClick}
                    displayShowMore={displayShowMore}
                    {...this.props}
                />
            );
        }
    };
}
